import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetUserScribephoneConsentQuery,
  GetUserScribephoneConsentQueryVariables,
} from "./ScribephoneConsent.generated";

export const GET_SCRIBEPHONE_CONSENT: TypedDocumentNode<
  GetUserScribephoneConsentQuery,
  GetUserScribephoneConsentQueryVariables
> = gql`
  query GetUserScribephoneConsent {
    user {
      uuid
      scribephoneConsentMode
      canChangeScribephoneConsent
    }
  }
`;
